import React from 'react';
import noContentBox from '../../../../assets/images/no-content-box.svg';
import emptySearchContent from '../../../../assets/images/emptySearchContent.svg';
import { WithChildren } from '../../../../models/children-props';
import { EmptyPlaceholder } from '../../../../components/containers/EmptyPlaceholder';
import { IconsEnum } from '../../../../constants/icons';
import { useNavigate } from 'react-router-dom';
import { SocialNetworksEnum } from '../../../../constants/social-networks';

export type NoContentBoxViewProps = WithChildren & {
  title: string;
  type: 'NO_RESULTS' | 'NEW_SEARCH' | 'NO_PROFILE';
  network?: SocialNetworksEnum;
};

enum NoProfileTitles {
  facebook = 'Looking for Facebook content? Just connect a Facebook Page',
  google = 'Looking for Google content? Just connect a Google Profile',
  instagram = 'Looking for Instagram content? Just connect an Instagram Profile',
  linkedin = 'Looking for LinkedIn content? Just connect a LinkedIn Profile',
  pinterest = 'Looking for Pinterest content? Just connect a Pinterest Profile',
  twitter = 'Looking for X (Twitter) content? Just connect a X (Twitter) Profile',
  tiktok = 'Looking for TikTok content? Just connect a TikTok Profile',
  bitly = 'bitly',
  youtube = 'youtube',
  universal = 'universal',
  threads = 'threads'
}

export const NoContentBoxView = (props: NoContentBoxViewProps): JSX.Element => {
  const navigate = useNavigate();
  const noProfileTitle = props.network ? NoProfileTitles[props.network] : '';

  const newSearch = (
    <EmptyPlaceholder title={'Import Content to your Queue'} image={noContentBox}>
      <p>
        Easily re-import your best content or find inspiration from other social feeds - whether importing a single post or dozens at once.
      </p>
      <p>
        Build your post library, repurpose top-performing posts, and adapt content for different platforms.
      </p>
      <p>
        You can also import from RSS feeds, and turn searches into Saved Feeds for quick access to the latest content.
      </p>
    </EmptyPlaceholder>
  );
  const noResults = (
    <EmptyPlaceholder title={'No Posts Found'} image={noContentBox}>
      <div>{/* @TODO: Copy */}</div>
    </EmptyPlaceholder>
  );
  const noProfile = (
    <EmptyPlaceholder
      title={noProfileTitle}
      image={emptySearchContent}
      buttonTitle={'Add Profile'}
      buttonIcon={IconsEnum.plus}
      buttonAction={() => navigate({ pathname: '/settings/profiles' })}>
      <div>{/* @TODO: Copy */}</div>
    </EmptyPlaceholder>
  );

  switch (props.type) {
    case 'NEW_SEARCH':
      return newSearch;
    case 'NO_RESULTS':
      return noResults;
    case 'NO_PROFILE':
      return noProfile;
    default:
      return newSearch;
  }
};
